import {
  ConfigureOptionsParams,
  FilterPassParams,
  AdvancedFilterName
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterHandlerBase } from './base/filter-handler-base';

export class ForwardDeliveryFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.forwardDelivery;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  configureFilterOptions(params: ConfigureOptionsParams): void {}

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const isForwardDelivery = params.filters[this.name];
    const data = params.deal;
    let isForwardDeliveryFilterPassed = true;

    if (isForwardDelivery && isForwardDelivery.model) {
      if (isForwardDelivery.model.value === 'Yes') {
        isForwardDeliveryFilterPassed = data.series.some(
          (series) => series.forwardInd
        );
      } else if (isForwardDelivery.model.value === 'No') {
        isForwardDeliveryFilterPassed = data.series.some((series) =>
          series.forwardInd === undefined || series.forwardInd === null
            ? true
            : series.forwardInd === false
        );
      }
    }
    result.applyDealFilerResult(
      data.id,
      this.name,
      isForwardDeliveryFilterPassed
    );
    return isForwardDeliveryFilterPassed;
  }
}
